module.exports = __webpack_public_path__ + "static/media/logo.b0cf15d8.png";